import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-12">
  <div className="container mx-auto px-6">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
      {/* Brand Column */}
      <div className="md:col-span-2">
        <Link to="/" className="flex items-center mb-6">
          <img
            src="/logo.png"
            alt="EquiCore Nexus Logo"
            className="h-14"
            style={{ filter: "invert(1)" }}
            loading="lazy"
          />
          <span className="ml-3 text-2xl font-bold">EquiCore Nexus</span>
        </Link>
        <p className="text-gray-400 mb-6 max-w-md">
          Global financial advisory firm helping startups & investors with 
          fundraising, M&A, and financial modeling.
        </p>
        <div className="flex space-x-4">
          <a href="https://www.linkedin.com/company/equicore-nexus/" className="bg-gray-800 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center transition">
            <i className="fab fa-linkedin-in" alt="LinkedIn"><span className="sr-only">LinkedIn</span></i>
          </a>
          <a href="https://www.facebook.com/share/1GEsbBkGKC/" className="bg-gray-800 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center transition">
            <i className="fab fa-facebook-f" alt="Facebook"><span className="sr-only">Facebook</span></i>
          </a>
        </div>
      </div>

      {/* Company Links */}
      <div>
        <h4 className="text-lg font-bold mb-6 relative pb-2 after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-blue-500">
          Company
        </h4>
        <ul className="space-y-3">
          <li><a href="/#about" className="text-gray-400 hover:text-blue-400 transition flex items-center">
            <i className="fas fa-chevron-right text-xs mr-2 text-blue-400"></i> About Us
          </a></li>
          <li><Link to="/case-studies" className="text-gray-400 hover:text-blue-400 transition flex items-center">
            <i className="fas fa-chevron-right text-xs mr-2 text-blue-400"></i> Case Studies
          </Link></li>
          <li><a href="/#services" className="text-gray-400 hover:text-blue-400 transition flex items-center">
            <i className="fas fa-chevron-right text-xs mr-2 text-blue-400"></i> Expertise
          </a></li>
          <li><a href="/#whyus" className="text-gray-400 hover:text-blue-400 transition flex items-center">
            <i className="fas fa-chevron-right text-xs mr-2 text-blue-400"></i> Why Us
          </a></li>
        </ul>
      </div>

      {/* Contact Info */}
      <div>
        <h4 className="text-lg font-bold mb-6 relative pb-2 after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-blue-500">
          Contact
        </h4>
        <ul className="space-y-4">
          <li className="flex items-start">
            <i className="fas fa-map-marker-alt text-blue-400 mt-1 mr-3"></i>
            <span className="text-gray-400">Delhi NCR, India</span>
          </li>
          {/* <li className="flex items-start">
            <i className="fas fa-phone-alt text-blue-400 mt-1 mr-3"></i>
            <span className="text-gray-400">+91 00000 00000</span>
          </li> */}
          <li className="flex items-start">
            <i className="fas fa-envelope text-blue-400 mt-1 mr-3"></i>
            <a href="mailto:info@ecnexus.co">
            <span className="text-gray-400 hover:text-blue-400 transition cursor-pointer">
              info@ecnexus.co
            </span></a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-gray-800 pt-10">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 mb-6 md:mb-0">
          <p className="text-gray-400">
            &copy; 2025 EquiCore Nexus. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="/privacy" className="text-gray-400 hover:text-blue-400 transition text-sm">
              Privacy Policy
            </a>
            <a href="/terms" className="text-gray-400 hover:text-blue-400 transition text-sm">
              Terms of Service
            </a>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <span className="text-gray-400 text-sm">Developed and hosted by <a
            href="https://kansals.in/"
            className="text-blue-400 hover:text-blue-600 transition"
            target="_blank"
            rel="noopener noreferrer">Kansals
            </a></span>
          
        </div>
      </div>
    </div>
  </div>
</footer>
  );
};

export default Footer;
